import Package from './Package';
import DetailsPackageHeader from '../components/DetailsPackageHeader';
import MoreAbout from '../components/PricingFooter/MoreAbout';

export default {
  Package,
  DetailsPackageHeader,
  MoreAbout,
};
